const useIsProductionApp = (): boolean => {
  return window.location.href.includes("https://vindrives.app/");
};

export default useIsProductionApp;